<mat-drawer-container class="sidenav-container" [class.sidenav-open]="drawerOpen" autosize>
  <mat-drawer
    (openedChange)="onOpenedChange($event)"
    #drawer
    position="end"
    autoFocus="false"
    mode="over"
    class="sidenav"
  >
    <div [hidden]="!(type === 'filters')">
      <app-asset-table-column-visibility-filter
        #stockFilters
        [columnVisibility]="columnVisibility"
        assetType="stock"
        [quantList]="quantList"
        [dynamicColumns]="dynamicColumns"
        (columnChanged)="onDynamicColumnChange($event)"
      ></app-asset-table-column-visibility-filter>
    </div>
    <div [hidden]="!(type !== 'filters' && drawlerData)" class="p-48 pe-0">
      <mat-form-field class="example-full-width">
        <mat-label>Search</mat-label>
        <input
          matInput
          placeholder="Search for..."
          [(ngModel)]="drawlerData.searchText"
          name="searchText"
        />
      </mat-form-field>
      <div class="selection-container">
        <button
          type="button"
          mat-button
          color="primary"
          (click)="drawlerData.selectAll()"
        >
          Select all
        </button>
        <button
          type="button"
          mat-button
          color="primary"
          (click)="drawlerData.deselectAll()"
        >
          Deselect all
        </button>
      </div>

      <mat-label>Choose an option</mat-label>
      <ul>
        @for (
          item of drawlerData.list | search: drawlerData.searchText;
          track item
        ) {
          <li
            [hidden]="
              item.hidden == true ||
              (drawlerData.hideMarked && item.marked == true)
            "
          >
            <mat-checkbox
              (change)="handleCheckboxUpdate(item.id)"
              [checked]="
                filters[drawlerData.name]
                  ? filters[drawlerData.name].includes(item.id.toString())
                  : false
              "
            >
              {{ item.name }}
            </mat-checkbox>
          </li>
        }
      </ul>
      <div class="selection-container bottom-buttons">
        <button
          type="button"
          mat-flat-button
          color="primary"
          (click)="filterCompanies(); drawer.toggle()"
        >
          OK
        </button>
        <button
          type="button"
          mat-button
          (click)="drawlerData.onPanelCloseOrCancel(); drawer.toggle()"
        >
          Cancel
        </button>
      </div>
    </div>
  </mat-drawer>
  <header class="ps-topbar">
    <a class="header-back" [routerLink]="['/app']">
      <mat-icon
        inline="true"
        fontSet="fa"
        fontIcon="fa-arrow-left"
        aria-label="back"
      ></mat-icon>
      <span>My portfolios</span>
    </a>
    <div class="ps-titlebar">
      <div class="step-header-left">
        @if (selectedStep === 1) {
          <h1>New portfolio <app-info infoIndex="3"></app-info></h1>
        } @else {
          <h1>Select assets <app-info infoIndex="2"></app-info></h1>
          @if (showUploadBtn) {
            <button
              type="button"
              class="ms-3"
              mat-flat-button
              color="primary"
              (click)="onUploadClick()"
            >
              Upload
            </button>
          }
        }
      </div>
      <div class="toolbar-buttons">
        @if (selectedStep === 1) {
          <button
            mat-stroked-button
            type="button"
            class="btn-ghost-outlined me-2"
            (click)="onBackClick()"
          >
            Back
          </button>
          <button
            mat-flat-button
            type="button"
            class="next-button"
            color="primary"
            [disabled]="weightSum !== 100"
            (click)="onSavePortfolioClick(portfolio)"
          >
            <span class="navigation-button">Save portfolio</span>
          </button>
        } @else {
          <button
            type="button"
            class="next-button"
            mat-flat-button
            color="primary"
            (click)="onNextClick()"
          >
            <span>Next</span>
            <mat-icon
              inline="true"
              fontIcon="chevron_right"
              aria-label="new portfolio"
            ></mat-icon>
          </button>
        }
      </div>
    </div>
  </header>

  <div class="pb-3">
    <mat-horizontal-stepper
      class="content-stepper portfolio-container"
      linear
      #stepper
      [selectedIndex]="selectedStep"
      (selectionChange)="stepChange($event)"
    >
      <mat-step>
        <app-new-portfolio
          [drawer]="drawer"
          [list]="list"
          [selected]="selected"
          [filterLists]="filterLists"
          [portfolio]="portfolio"
          [meta]="meta"
          [priorityCurrencies]="priorityCurrencies"
          (nextClick)="onNextClick()"
          (getFilters)="getFiltersIn($event)"
          (fetchCompanies)="fetchCompaniesIn($event, 1)"
          (itemSelect)="onCompanySelect($event)"
          (selectAll)="onSelectAll($event)"
          (pageEvent)="onPageEvent($event)"
          (cartClick)="onPortfolioCartClick()"
          (startDateChange)="onMaxStartDateChange($event)"
          (fileUploaded)="onFileUploaded($event)"
          (selectedSortingChanged)="changeSelectedSorting($event)"
          [portfolioList]="portfolioList"
          [selectedPortfolioIds]="selectedPortfolioIds"
          [portfolioMeta]="portfolioMeta"
          (fetchPortfolios)="fetchPortfoliosIn($event)"
          (portfolioPageEvent)="onPortfolioPageEvent($event)"
        ></app-new-portfolio>
      </mat-step>
      <mat-step>
        @if (weightSum !== 100) {
          <div
            class="alert alert-warning d-flex align-items-center gap-2 mb-4"
            role="alert"
          >
            <mat-icon
              fontSet="fa"
              fontIcon="fa-exclamation-triangle"
            ></mat-icon>
            <span>
              The total weight of your portfolio is
              <strong>{{ weightSum }}%</strong>, not 100%. Please adjust the
              individual weights before saving.
            </span>
          </div>
        }
        @if (notFoundISINs?.length) {
          <div
            class="alert alert-warning d-flex align-items-center gap-2 mb-4"
            role="alert"
          >
            <mat-icon
              fontSet="fa"
              fontIcon="fa-exclamation-triangle"
            ></mat-icon>
            <span>
              <strong
                >{{ notFoundISINs.length }} ISIN{{
                  notFoundISINs.length === 1 ? "" : "s"
                }}
                not found</strong
              >
              during file upload and could not be added to your portfolio:
              <span class="font-monospace">{{
                notFoundISINs.join(", ")
              }}</span
              >.
            </span>
          </div>
        }

        <div class="mb-4">
          @if (selectedStep == 1) {
            <app-manual-portfolio-form
              [portfolio]="portfolio"
              [maxStartDate]="max_start_date"
              [filterLists]="filterLists"
              [selectedCurrencies]="selectedCurrencies"
              [hasETF]="hasETF"
              (portfolioSave)="onSavePortfolioClick($event)"
              (weightChange)="onWeightTypeChange()"
              (startDateSet)="onStartDateSet()"
              (setAllEqual)="setAllAssetEqual()"
            ></app-manual-portfolio-form>
          }
        </div>

        <div class="card mb-4">
          <div class="card-body">
            @if (portfolio) {
              <app-new-portfolio-select-dialog
                [list]="selected"
                [portfolio]="portfolio"
                (itemRemove)="onCompanySelect($event)"
              ></app-new-portfolio-select-dialog>
            }
          </div>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</mat-drawer-container>
